// export default {
//   methods: {
//     filterRoles(role) {
//       if (!this.$store.getters["roles"].length) {
//         this.$store.dispatch("getRoles").then((roles) => {
//           return this.$store.getters["roles"].find((r) => {
//             return r.title === role;
//           })._id;
//         });
//       } else {
//         return this.$store.getters["roles"].find((r) => {
//           return r.title === role;
//         })?._id;
//       }
//     },
//   },
// };

export default {
  methods: {
    async filterRoles(role) {
      if (!this.$store.getters["roles"].length) {
        await this.$store.dispatch("getRoles");
      }

      const foundRole = this.$store.getters["roles"].find((r) => r.title === role);
      return foundRole?._id;
    },
  },
};